const randomReward = {
  path: "",
  name: "",
  redirect: "/random-reward",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/random-reward",
      redirect: "/random-reward",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Random Reward",
      meta: {
        requiresAuth: true,
        activeUrl: "/random-reward",
        parent: "/random-reward",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/randomReward"),
          meta: {
            requiresAuth: true,
            activeUrl: "/random-reward",
            parent: "/random-reward",

            lv: 2,
          },
        },
        {
          path: "detail/:id",
          name: "Random Reward Detail",
          component: () => import("@/views/pages/randomReward/detail"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/random-reward",
            parent: "/random-reward",

            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default randomReward;
